import RouterService from 'client/util/RouterService';

export default {
  methods: {
    closeAsidePanel() {
      RouterService.redirect({
        path: this.route,
        triggeredEvent: this.asidePanelCanceledEventName,
        viewport: this.viewport,
        vueRouter: this.$router,
      });
    },

    getItem() {
      return this.$refs.itemTable.getItem();
    },

    getItemsToBind() {
      return this.$refs.itemTable.getItemsToBind();
    },

    getItemsToUnbind() {
      return this.$refs.itemTable.getItemsToUnbind();
    },

    handleDetailsButtonClick(itemId) {
      if (this.inMainPanel) {
        RouterService.redirect({
          path: `${this.route}/${itemId}/details`,
          viewport: this.viewport,
          vueRouter: this.$router,
        });
      }
    },

    handleRowClick(itemId) {
      this.handleDetailsButtonClick(itemId);
    },

    hide() {
      this.$refs.itemTable.hide();
    },

    isRowExpanded(rowId) {
      return this.$refs.itemTable && this.$refs.itemTable.isExpanded(rowId);
    },

    refresh() {
      this.$refs.itemTable.refresh();
    },

    show() {
      this.$refs.itemTable.show();
    },
  },
};
